type IconProps = {
  width?: string;
  height?: string;
};

const CircleLoading = ({ width, height }: IconProps) => {
  return (
    <svg
      width={width ?? "120"}
      height={height ?? "120"}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="60" cy="60" r="56" stroke="#F4F4F4" strokeWidth="8" />
      <path
        d="M7.00789 78.1063C4.12746 69.676 3.29988 60.6802 4.5939 51.8659C5.88791 43.0516 9.26617 34.6732 14.4481 27.4266C19.63 20.18 26.4661 14.2742 34.3886 10.1999C42.311 6.12546 51.0912 4 60 4"
        stroke="#2977EC"
        strokeWidth="8"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CircleLoading;
